import StockApi from './StockApi'
import dayjs from 'dayjs'

const TypesReceivement = {
  MERCEARIA: 1,
  FRESH: 2
}

export const OriginErrorTypes = {
  GENERAL_STOCK: 'general_stock'
}

const validateBarcodeUser = (barcodeUser) => {
  return StockApi.get('/usuario/valida', { params: { barcodeUser } })
    .then(() => {
      return true
    })
    .catch(() => {
      return false
    })
}

const ObjectToLabelPrint = (obj, label) => {
  label.obj = obj
  return label
}

const WhiteSpaceTreatement = (object) => {
  for (const key of Object.keys(object)) {
    if (typeof object[key] === 'string' && !object[key]) {
      object[key] = ' '
    }
  }
  return object
}

function getUniqueListBy(arr, key) {
  return [...new Map(arr.map((item) => [item[key], item])).values()]
}

const ValidateBarcodeProduct = (value) => {
  const regexBarCodeProduct = /[\/\-._a-zA-Z0-9\s]+([\/\-a-zA-Z0-9._])*$/g

  return regexBarCodeProduct.test(value)
}

export const addLeadingZeros = (num, size) => {
  const originalNum = num.replace(/^0+/, '')
  if (originalNum.length > 3) return originalNum.substring(0, 3)
  let string = `${originalNum}`
  while (string.length < size) string = `0${string}`
  return string
}

export const resultToSuccess = ({ data, status, statusText }) => ({
  data,
  status,
  statusText,
  isOk: true
})

export const resultToFailed = (responseFailed) => {
  const { response, message } = responseFailed
  if (response === undefined) {
    return {
      data: {
        message
      }
    }
  }
  const { data, status, statusText } = response
  return { data, status, statusText, isOk: false }
}

export const optionsFor = (userId) => ({ headers: { 'user-barcode': userId } })

export const badgeHeader = (badge) => ({ 'user-barcode': badge })

export const safeFetch = async (fetchFunction) => {
  try {
    const result = await fetchFunction()
    return resultToSuccess(result)
  } catch (error) {
    return resultToFailed(error)
  }
}

export const validateDate = (value) => {
  const isValidDate = dayjs(value).isAfter(dayjs())
  return isValidDate
}

export default {
  validateBarcodeUser,
  ObjectToLabelPrint,
  TypesReceivement,
  OriginErrorTypes,
  WhiteSpaceTreatement,
  getUniqueListBy,
  ValidateBarcodeProduct,
  addLeadingZeros,
  validateDate
}
